module.exports = __webpack_public_path__ + "img/sonar.db8f6e11.svg";